import React, { memo, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Form } from 'react-final-form';

import CommonModal from '../../components/common-modal/CommonModal';
import { changeUserPassword } from '../../redux/user-management/userManagementActions';
import validate from '../../utils/validate';
import ChangeUserPasswordForm from './ChangeUserPasswordForm';
import { changeUserPasswordYupValidation } from './validation';

const ChangeUserPasswordModal = ({ isOpen, onClose, username }) => {
  const dispatch = useDispatch();

  const changePasswordInitialValues = {
    oldPassword: '',
    password: '',
    repeatPassword: '',
  };

  const handleChangePassword = useCallback(
    ({ password, oldPassword }) => {
      dispatch(changeUserPassword({ username, oldPassword, newPassword: password }));
      onClose();
    },
    [dispatch, username, onClose],
  );

  return (
    <CommonModal isOpen={isOpen} onClose={onClose}>
      <Form
        initialValues={changePasswordInitialValues}
        onSubmit={handleChangePassword}
        validate={(values) => validate(values, changeUserPasswordYupValidation())}
        subscription={{ submitting: true, pristine: true }}
        render={({ handleSubmit }) => <ChangeUserPasswordForm handleSubmit={handleSubmit} />}
      />
    </CommonModal>
  );
};

export default memo(ChangeUserPasswordModal);
